/**
 * All UI strings, nb-NO. Flat typed object — no i18n library in v1 (plans README).
 */
export const msg = {
  app: {
    name: 'LOS',
  },
  common: {
    back: 'Tilbake',
  },
  nav: {
    tabNavigate: 'Naviger',
    tabPlan: 'Planlegg',
    tabTracks: 'Turer',
    sog: 'Fart',
    cog: 'Kurs',
    trip: 'Tur',
    follow: 'Følg posisjon',
    zoomIn: 'Zoom inn',
    zoomOut: 'Zoom ut',
    depth: 'Dybdedata',
    seamarks: 'Sjømerker',
    measure: 'Mål avstand',
  },
  measure: {
    hint: 'Trykk i kartet for å måle',
    lastLeg: 'siste etappe',
    undo: 'Angre',
    close: 'Avslutt måling',
  },
  units: {
    kn: 'kn',
    nm: 'nm',
  },
  gps: {
    idle: 'GPS av',
    acquiring: 'Søker GPS …',
    ok: 'GPS',
    stale: 'GPS svak',
    lost: 'GPS mistet',
    denied: 'GPS avslått',
    unavailable: 'GPS utilgjengelig',
  },
  theme: {
    toggle: 'Dag/natt',
    day: 'Dag',
    night: 'Natt',
  },
  tracks: {
    logger: 'LOGGER',
    stopTitle: 'Avslutt turen?',
    stopBody: 'Turen lagres automatisk. Vil du avslutte opptaket nå?',
    stopConfirm: 'Avslutt tur',
    keepRecording: 'Fortsett',
    cancel: 'Avbryt',
    empty: 'Ingen turer ennå. Turer logges automatisk når du er i fart.',
    emptyTitle: 'Ingen turer ennå',
    emptyBody: 'Turene dine logges automatisk mens du er i fart. Neste gang du er ute, dukker de opp her.',
    showMore: 'Vis flere',
    rename: 'Gi nytt navn',
    delete: 'Slett tur',
    deleteConfirm: 'Slett denne turen?',
    exportGpx: 'Eksporter GPX',
    stats: {
      distance: 'Distanse',
      duration: 'Varighet',
      avg: 'Snittfart',
      max: 'Maks',
    },
    gpxTabHint: 'Filen åpnes i ny fane — bruk «Del» eller «Last ned» for å lagre.',
  },
  settings: {
    title: 'Innstillinger',
    mapSection: 'Kart',
    theme: 'Tema',
    themeAuto: 'Auto',
    themeDay: 'Dag',
    themeNight: 'Natt',
    trail: 'Spor etter båt',
    trailOff: 'Av',
    trailShort: 'Kort',
    trailMedium: 'Middels',
    trailLong: 'Lang',
    predictor: 'Kurslinje',
    predictorOff: 'Av',
    predictor1: '1 min',
    predictor3: '3 min',
    predictor6: '6 min',
    unitsSection: 'Enheter',
    unitSpeed: 'Fart',
    unitDistance: 'Distanse',
    unitConsumption: 'Forbruk',
    unitCourse: 'Kurs',
    courseTrue: 'Rettvisende',
    courseMagnetic: 'Magnetisk',
    displaySection: 'Visning',
    textSize: 'Tekststørrelse',
    textSmall: 'Liten',
    textNormal: 'Normal',
    textLarge: 'Stor',
    textXLarge: 'Størst',
    boatSection: 'Båt',
    boatLink: 'Min båt',
    aboutSection: 'Om',
    version: 'Versjon',
    setupGuide: 'Klargjør enheten for båtbruk',
    disclaimerLink: 'Ansvarsfraskrivelse',
    offlineSection: 'Kart offline',
    storageUsed: 'Brukt lagring',
    of: 'av',
    downloadRegion: 'Last ned kartområde',
    noRegions: 'Ingen nedlastede områder.',
    onlineOnly:
      'Denne enheten støtter ikke offline-kart. Appen fungerer online. Legg til på Hjem-skjerm for best opplevelse.',
    delete: 'Slett',
    incomplete: 'Ufullstendig',
    tiles: 'kartfliser',
    staleDepth: 'Kartområdet har eldre dybdedata — last ned på nytt.',
  },
  region: {
    title: 'Velg område',
    hint: 'Panorer og zoom til området du vil ha offline.',
    estimate: 'Beregnet',
    download: 'Last ned',
    downloading: 'Laster ned …',
    cancel: 'Avbryt',
    done: 'Ferdig',
    tooLarge: 'Velg et mindre område.',
    name: 'Områdenavn',
    close: 'Lukk',
  },
  install: {
    title: 'Legg til på Hjem-skjerm',
    body: 'For at offline-kart skal overleve på iOS må appen ligge på Hjem-skjermen. Trykk Del-knappen og velg «Legg til på Hjem-skjerm».',
    ok: 'Skjønner',
  },
  boat: {
    title: 'Min båt',
    add: '+ Legg til båt',
    empty: 'Ingen båt lagt til. Legg til én for å planlegge ruter.',
    name: 'Navn',
    namePlaceholder: 'F.eks. Draken',
    draught: 'Dypgang',
    cruise: 'Marsjfart',
    clearance: 'Klaring',
    fuel: 'Forbruk',
    tank: 'Tankvolum',
    tankOptional: 'valgfritt',
    range: 'Rekkevidde',
    delete: 'Slett båt',
    deleteBlocked: 'Du må ha minst én båt.',
    saved: 'Lagret ✓',
    active: 'Aktiv',
    setActive: 'Velg',
    done: 'Ferdig',
    unitPerNm: 'l/nm',
    unitPerH: 'l/t',
  },
  planner: {
    title: 'Planlegg',
    newRoute: 'Ny rute',
    tapToAdd: 'Trykk i kartet for å legge til veipunkter.',
    noBoat: 'Legg til en båt for tid og drivstoff.',
    leg: 'Etappe',
    dist: 'Dist',
    time: 'Tid',
    fuel: 'Drivstoff',
    total: 'Totalt',
    arrival: 'Ankomst',
    save: 'Lagre rute',
    saved: 'Rute lagret ✓',
    clear: 'Tøm',
    routeName: 'Rutenavn',
    savedRoutes: 'Lagrede ruter',
    follow: 'Følg rute',
    fuelWarn: 'Fyll drivstoff underveis?',
    waypoint: 'Veipunkt',
    insertAfter: 'Sett inn etter',
    deleteWp: 'Slett veipunkt',
    list: 'Liste',
    listTitle: 'Veipunkter',
    moveUp: 'Flytt opp',
    moveDown: 'Flytt ned',
    empty: 'Ingen lagrede ruter ennå.',
    xte: 'XTE',
    toWp: 'Til punkt',
    stopFollow: 'Avslutt',
    suggest: 'Foreslå rute',
    pickStart: 'Trykk startpunkt i kartet',
    pickEnd: 'Trykk mål i kartet',
    suggesting: 'Beregner trygg rute …',
    suggestCancel: 'Avbryt',
    autoBanner:
      'Automatisk forslag — kontroller mot kartet. Bruer, kraftlinjer og seilingshøyde er ikke vurdert.',
    failNoRoute: 'Fant ingen trygg rute for dypgang + klaring. Del opp i kortere etapper.',
    failGeneric: 'Kunne ikke beregne rute.',
    failNoData: 'Mangler dybdedata for området.',
  },
  auth: {
    tagline: 'Kystnavigasjon — også uten dekning',
    email: 'E-post',
    password: 'Passord',
    login: 'Logg inn',
    register: 'Opprett konto',
    forgot: 'Glemt passord?',
    toRegister: 'Ny her? Opprett konto',
    toLogin: 'Har du konto? Logg inn',
    genericError: 'Feil e-post eller passord',
    offline: 'Innlogging krever nett. Resten av appen virker uten.',
    footer: 'Appen virker uten konto — innlogging trengs for synk og offline-kart.',
    continueAnon: 'Fortsett uten konto',
    resetTitle: 'Tilbakestill passord',
    resetSent: 'Hvis e-posten finnes, er en lenke sendt.',
    resetSend: 'Send lenke',
    newPassword: 'Nytt passord',
    resetConfirm: 'Lagre nytt passord',
    resetDone: 'Passordet er endret. Logg inn.',
    working: 'Vent …',
  },
  account: {
    section: 'Konto',
    loggedOut: 'Logg inn eller opprett konto',
    email: 'E-post',
    purchaseYes: 'LOS Full ✓',
    purchaseNo: 'LOS Full — 49 kr',
    buy: 'Kjøp',
    logout: 'Logg ut',
    deleteAccount: 'Slett konto …',
    deleteConfirm: 'Slett konto og alle data?',
    deleteBody: 'Dette kan ikke angres. Skriv passordet ditt for å bekrefte.',
    lastSynced: 'Sist synkronisert',
    syncing: 'Synkroniserer …',
    syncPending: 'Venter på nett',
    syncError: 'Synk feilet',
  },
  disclaimer: {
    title: 'Kun som navigasjonshjelp',
    body: 'LOS er et hjelpemiddel og erstatter ikke offisielle sjøkart eller forsvarlig sjømannskap. Bruk aldri appen som eneste kilde til navigasjon.',
    accept: 'Jeg forstår',
  },
  conditions: {
    title: 'Vær og vannstand',
  },
  weather: {
    title: 'Vær',
    wind: 'Vind',
    gust: 'Vindkast',
    precip: 'Nedbør',
    temp: 'Temp',
    hour: 'Time',
    updated: 'sist oppdatert',
    fetchRoute: 'Hent vær for ruta',
    alongRoute: 'Vind underveis',
    fetchingRoute: 'Henter vær …',
    attribution: 'Værdata © MET Norge (NLOD/CC BY 4.0)',
  },
  tide: {
    title: 'Vannstand',
    now: 'Vannstand nå',
    high: 'Flo',
    low: 'Fjære',
    aboveDatum: 'over sjøkartnull',
    updated: 'sist oppdatert',
    depthPrefix: 'Karttall + vannstand:',
    attribution: 'Vannstand © Kartverket (Se havnivå)',
  },
  search: {
    title: 'Søk',
    placeholder: 'Søk etter sted',
    // One honest phrasing for both "genuinely no matches" and "fetch
    // failed" — the sheet can't reliably tell them apart, so it never
    // claims more certainty than it has (spec 13: no error dialog).
    empty: 'Ingen treff / ingen nett',
    recents: 'Nylige søk',
    pickInMap: 'Velg i kartet',
    close: 'Lukk',
  },
  goto: {
    gotoHere: 'Gå hit',
    to: 'Til',
    clear: 'Fjern mål',
    suggestRoute: 'Foreslå rute hit',
    cancel: 'Avbryt',
    confirmTitle: 'Sett som mål?',
    pickHint: 'Trykk i kartet for å velge punkt',
  },
  setup: {
    title: 'Klargjør enheten for båtbruk',
    intro:
      'For at turlogging skal fungere må skjermen holdes på under turen. Nettleseren kan ikke logge når skjermen er av.',
    iosTitle: 'iPhone / iPad',
    iosBody:
      'Slå av automatisk skjermlås: Innstillinger → Skjerm og lysstyrke → Auto-lås → Aldri. Husk å sette den tilbake når du er i land — dette er en global innstilling.',
    androidTitle: 'Android',
    androidBody:
      'LOS holder skjermen våken automatisk mens kartet vises. Stock Android har ingen «aldri»-innstilling, så la appen ligge åpen i forgrunnen.',
    powerTitle: 'Strøm',
    powerBody: 'Koble telefonen til 12V-strøm i båten — skjerm på tapper batteriet fort.',
    gapNote: 'Skjermen ser ut til å ha vært av. Sjekk oppsettet over så turen logges videre.',
    ok: 'Skjønner',
  },
  share: {
    title: 'Del turen',
    chip: 'DELER',
    explain: 'Del posisjonen din i sanntid med en lenke — familien trenger verken konto eller app for å følge med.',
    privacyNote: 'Lenken slutter å virke og posisjonene slettes.',
    start: 'Start deling (24 t)',
    starting: 'Starter deling …',
    startFailed: 'Kunne ikke starte deling. Prøv igjen.',
    linkLabel: 'Lenke',
    timeLeft: 'Tid igjen',
    viewerHint: 'Alle med lenken kan se posisjonen til delingen avsluttes.',
    copy: 'Kopier lenke',
    copied: 'Lenke kopiert',
    shareLink: 'Del lenke',
    stop: 'Stopp deling',
    stopping: 'Avslutter …',
    close: 'Lukk',
    viewer: {
      lastSeen: 'sist sett',
      boatFallback: 'Båt',
      loading: 'Laster inn …',
      ended: 'Delingen er avsluttet',
      endedBody: 'Lenken virker ikke lenger, og posisjonene er slettet.',
      notFound: 'Fant ikke delingen',
      notFoundBody: 'Lenken er ugyldig eller feil skrevet.',
      footer: 'LOS-deling er ikke et nødsystem.',
    },
  },
  ais: {
    toggle: 'Fartøy (AIS)',
    disclaimer: 'AIS kan være forsinket og ufullstendig.',
    attribution: 'AIS © Kystverket / BarentsWatch',
    zoomInHint: 'Zoom inn for AIS',
    lastSeen: 'sist sett',
    cappedChip: 'fartøy — zoom inn',
    mmsiPrefix: 'MMSI',
    sog: 'SOG',
    course: 'KURS',
    close: 'Lukk',
    types: {
      pleasure: 'Fritidsbåt',
      fishing: 'Fiskefartøy',
      cargo: 'Lasteskip',
      tanker: 'Tankskip',
      passenger: 'Passasjer',
      highspeed: 'Hurtiggående',
      tug: 'Taubåt',
      other: 'Annet',
    },
  },
} as const;
